<template>
  <div class="group-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @changeCompany="changeCompany"
          @getTreeData="getTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          ></time-search>
        </div>
        <div v-loading="loading">
          <div class="chart-content">
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="chart-box">
                  <div class="title">用电趋势图</div>
                  <div class="chart" id="lineChart"></div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="chart-box table-content">
            <div
              class="same-item"
              v-for="(item, index) in sameData"
              :key="index"
            >
              <same
                :obj="item"
                unit="kWh"
                type="tq"
                :sameTitle="sameTitle"
              ></same>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue"
import { itemColor } from "@/config/data.js"
import BtnShow from "@/components/common/BtnShow.vue"
import TimeSearch from "@/components/common/TimeSearch.vue"
import api from "@common/api/index.js"
import { findDataByParam } from "@/utils/index.js"
import handleData from "@/utils/handleData.js"
import NkTable from "@/components/common/NkTable.vue"
import echarts from "echarts"
import ResizeContainer from "@/components/common/resizeContainer.vue"
import Same from "./page/same.vue"
import dateTool from "@/utils/dateTool.js"
let eleTimeData = [
  {
    type: "day",
    label: "日"
  },
  {
    type: "month",
    label: "月"
  }
  //   {
  //     type: "year",
  //     label: "年",
  //   },
]
export default {
  components: { TabTree, BtnShow, TimeSearch, NkTable, Same, ResizeContainer },
  data() {
    return {
      tabShow: true,
      viewTreeData: [],
      viewNodeData: [],
      timeData: eleTimeData,
      selectedMeasure: {
        id: "",
        measureName: ""
      },
      selectedDate: {
        startTime: "",
        endTime: ""
      },
      TypeOfElectricityConsumption: [
        { name: "Ele", label: "电力" },
        { name: "DieselOil", label: "柴油" },
        { name: "Water", label: "水" },
        { name: "NaturalGas", label: "天然气" }
      ],
      lineCharts: null,
      pieCharts: null,
      tableData: [],
      sameData: [],
      sameTitle: {
        current: { thisYear: "当年", today: "当天", thisMonth: "当月" },
        prev: { thisYear: "去年", today: "去年今天", thisMonth: "去年今月" }
      },
      loading: true
    }
  },
  created() {},
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this
    vm.drawLine()
  },
  methods: {
    changeCompany(companyId) {
      let vm = this
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/class/groupSame", null)
        .then(res => {
          const viewTreeData = findDataByParam("viewTree", true, res.data)
          vm.viewTreeData = viewTreeData
        })
    },
    timeControlChange(e) {
      this.selectedDate = e
    },
    TimeControlClick(e) {
      let vm = this
      vm.selectedDate = e
      vm.getData()
    },
    getTreeData(data) {
      let vm = this
      vm.viewNodeData = data
    },
    tabTreeDefault(e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    tabTreeClick(e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    async getData() {
      let vm = this
      vm.loading = true
      let className = []
      let classNameOne = ["总能耗"]

      const selectedObj = vm.viewNodeData.find(
        it => it.measureId === vm.selectedMeasure.id
      )
      if (!selectedObj) return
      const measures = []
      const measureIds = []
      const pointCode = 100229
      const pointNumber = 0
      const isRang = 0

      let list = [selectedObj]
      const { children, measureId, measureName } = list[0]
      measures.push({ measureId, pointCode, pointNumber })

      if (children.length) {
        children.forEach(item => {
          const { measureId, measureName } = item
          measures.push({ measureId, pointCode, pointNumber })
          classNameOne.push(measureName)
          className.push(measureName)
          list.push(item)
          measureIds.push(measureId)
        })
      } else {
        className.push(measureName)
        measureIds.push(measureId)
      }

      let startTime = vm.selectedDate.startTime
      let endTime = vm.selectedDate.endTime
      let dateType = vm.selectedDate.dateType
      //同期时间
      let startTimeSame = null
      let endTimeSame = null
      let xData = []
      let xDataSame = []
      let apiName = ""
      if (dateType == "day") {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        )
        endTimeSame = dateTool.format(
          new Date(
            new Date(endTime).setFullYear(new Date(endTime).getFullYear() - 1)
          ),
          "yyyy-MM-dd hh:mm:ss"
        )
        xData = handleData.createXData("0", startTime, endTime, false)
        xDataSame = handleData.createXData(
          "0",
          startTimeSame,
          endTimeSame,
          false
        )
        apiName = "getQuantityHour2"
      } else if (dateType == "month") {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        )
        endTimeSame = dateTool.format(
          new Date(
            new Date(endTime).setFullYear(new Date(endTime).getFullYear() - 1)
          ),
          "yyyy-MM-dd hh:mm:ss"
        )
        xData = handleData.createXData("2", startTime, endTime, false)
        xDataSame = handleData.createXData(
          "2",
          startTimeSame,
          endTimeSame,
          false
        )
        apiName = "getQuantityDay3"
      } else {
        startTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        )
        endTimeSame = startTime
        xData = handleData.createXData("5", startTime, endTime, false)
        xDataSame = handleData.createXData(
          "5",
          startTimeSame,
          endTimeSame,
          false
        )
        apiName = "getQuantityMonth2"
      }
      let infoTime = dateTool.format(new Date(), "yyyy-MM-dd ") + "00:00:00"
      if (dateType == "day") {
        infoTime =
          dateTool.format(new Date(startTime), "yyyy-MM-dd ") + "00:00:00"
      }
      Promise.all([
        api.quantity[apiName](measures, startTime, endTime, 0),
        api.quantity[apiName](measures, startTimeSame, endTimeSame, 0),
      ]).then(async resArr => {
        // 曲线图
        let apiData = resArr[0].data
        let lineItem = apiData.find(
          c => c.measureId == vm.selectedMeasure.measureId
        )
        let apiData2 = resArr[1].data
        let lineItemSame = apiData2.find(
          c => c.measureId == vm.selectedMeasure.measureId
        )
        if (dateType == "month" && !children.length) {
          lineItem.data = lineItem.data[0]
          lineItemSame.data = lineItemSame.data[0]
        }

        let line = {
          xAxis: {
            type: "category",
            data: []
          },
          series: []
        }
        let legendData = []
        let colorArr = []
        for (let i = 0; i < className.length; i++) {
          if (children.length && i) {
            lineItem = apiData.find(
              c => c.measureId == children[i - 1].measureId
            )
            lineItemSame = apiData2.find(
              c => c.measureId == children[i - 1].measureId
            )
            if (dateType == "month") {
              lineItem.data = lineItem.data[0]
              lineItemSame.data = lineItemSame.data[0]
            }
          }

          let seriesItem = {
            data: [],
            type: "bar",
            barGap: 0,
            name: className[i],
            stack: "总量",
            label: {
              show: false
            }
          }
          let seriesItem2 = {
            data: [],
            type: "bar",
            name: className[i] + "同期",
            stack: "同期总量",
            label: {
              show: false
            }
          }
          legendData.push(className[i], className[i] + "同期")
          colorArr.push("red", "red")
          for (let j = 0; j < xData.length; j++) {
            if (i == 0) {
              line.xAxis.data.push(xData[j].title)
            }
            const dataItem = lineItem.data?.find(
              c => new Date(c.time).getTime() == xData[j].value
            )
            if (dataItem) {
              seriesItem.data.push(dataItem.value.toFixed(2))
            } else {
              seriesItem.data.push("")
            }
            // seriesItem.data.push(dataItem ? dataItem.values[i] : "");
            if (xDataSame.length > j) {
              const dataItem2 = lineItemSame.data?.find(
                c => new Date(c.time).getTime() == xDataSame[j].value
              )
              if (dataItem2) {
                seriesItem2.data.push(dataItem2.value.toFixed(2))
              } else {
                seriesItem2.data.push("")
              }
            } else {
              seriesItem2.data.push("")
            }
            // seriesItem2.data.push(dataItem2 ? dataItem2.values[i] : "");
          }
          line.series.push(seriesItem)
          line.series.push(seriesItem2)
        }
        //获取分项用电颜色
        for (let z = 0; z < legendData.length; z++) {
          for (let i = 0; i < itemColor.length; i++) {
            if (legendData[z].indexOf(itemColor[i].name) > -1) {
              colorArr[z] = itemColor[i].color
            }
          }
        }
        let option = vm.lineCharts.getOption()
        option.legend = {
          type: "scroll",
          top: 0,
          left: 80,
          data: (function() {
            return legendData
          })()
        }
        option.xAxis = line.xAxis
        // option.color = colorArr
        option.color = [
          "#00AAFF",
          "#52CCA3",
          "#CCCC00",
          "#E67A45",
          "#E62E4D",
          "#8673E6",
          "#E673E6",
          "#66CCFF"
        ]
        option.series = line.series
        vm.lineCharts.setOption(option, true)
        await vm.getSameData(measureIds)
        vm.loading = false
      })
    },
    async getSameData(measureIds) {
      const vm = this;
      const startTime = vm.selectedDate.startTime
      const endTime = vm.selectedDate.endTime
      const measures = measureIds.map(k => ({measureId: k, pointCode: 100229, pointNumber: 0}))
      let sameData = measureIds.map(k => {
        const obj = vm.viewNodeData.find(
          it => it.measureId === k
        )
        return {
          currentDayValue: "-", currentMonthValue : "-", currentYearValue : "-", dayRatio : "-", lastDayValue : "-", lastMonthValue : "-", lastYearValue : "-", className: obj.measureName, measureId : k, monthRatio : "-", yearRatio : "-", }
      });
      const dayStartTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        );
      const monthStartTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        );
      const yearStartTimeSame = dateTool.format(
          new Date(
            new Date(startTime).setFullYear(
              new Date(startTime).getFullYear() - 1
            )
          ),
          "yyyy-MM-dd hh:mm:ss"
        );

      const [dayRes, monthRes, yearRes] = await Promise.all([
        api.quantity.getQuantityDay3(measures, dayStartTimeSame, startTime),
        api.quantity.getQuantityMonth2(measures, monthStartTimeSame, startTime),
        api.quantity.getQuantityYear2(measures, yearStartTimeSame, startTime)
      ])
      dayRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          sameData[index]['lastDayValue'] = k[0]?.value || '-'
          sameData[index]['currentDayValue'] = k[1]?.value || '-'
          if (sameData[index]['currentDayValue'] === '-') {
              sameData[index]['dayRatio'] = '-'
          } else {
            sameData[index]['dayRatio'] = ((sameData[index]['currentDayValue'] - sameData[index]['lastDayValue']) / sameData[index]['lastDayValue'] * 100).toFixed(2) || 0
          }
        })
      })
      monthRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          sameData[index]['lastMonthValue'] = k.value || '-'
          sameData[index]['currentMonthValue'] = k.value || '-'
          if (sameData[index]['currentMonthValue'] === '-') {
              sameData[index]['monthRatio'] = '-'
          } else {
            sameData[index]['monthRatio'] = ((sameData[index]['currentMonthValue'] - sameData[index]['lastMonthValue']) / sameData[index]['lastMonthValue'] * 100).toFixed(2) || 0
          }
        })
      })
      yearRes.data.forEach((it, index) => {
        it.data.forEach((k, i) => {
          sameData[index]['lastYearValue'] = k.value || '-'
          sameData[index]['currentYearValue'] = k.value || '-'
          if (sameData[index]['currentYearValue'] === '-') {
              sameData[index]['yearRatio'] = '-'
          } else {
            sameData[index]['yearRatio'] = ((sameData[index]['currentYearValue'] - sameData[index]['lastYearValue']) / sameData[index]['lastYearValue'] * 100).toFixed(2) || 0
          }
        })
      })

      vm.sameData = sameData;
    },
    drawLine() {
      let vm = this
      this.lineCharts = echarts.init(document.getElementById("lineChart"))
      let option = {
        legend: {
          textStyle: {
            color: "#bcbdbe"
          }
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2
            }
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe"
            }
          }
        },
        grid: {
          x: 66,
          y: 30,
          x2: 20,
          y2: 30
        },
        yAxis: [
          {
            type: "value",
            name: "kWh"
          }
        ],
        // yAxis: {
        //   type: "value",
        //   name: "kgce",
        //   nameTextStyle: {
        //     //y轴上方单位的颜色
        //     color: "#878b97",
        //   },
        //   scale: true /*按比例显示*/,
        //   axisLine: {
        //     lineStyle: {
        //       color: "#bcbdbe",
        //       width: 2,
        //     },
        //   },
        //   axisLabel: {
        //     textStyle: {
        //       color: "#bcbdbe",
        //     },
        //   },
        //   splitLine: {
        //     show: true,
        //     lineStyle: {
        //       color: ["#bcbdbe"],
        //       width: 1,
        //       type: "solid",
        //     },
        //   },
        // },
        label: {},
        tooltip: {
          trigger: "axis",
          confine: true,
          textStyle: {
            align: "left"
          }
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //     magicType: {
        //       type: ["line", "bar"],
        //     }, //切换为折线图，切换为柱状图
        //   },
        //   right: "40",
        // },
        color: [],
        series: []
      }
      this.lineCharts.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.group-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  min-width: 200px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: transparent;
}
.search-box {
  height: 40px;
}
.chart-content {
  margin-top: 14px;
  width: 100%;
}
.chart-box {
  width: 100%;
  height: 400px;
  border-radius: 4px;
  background: #ffffff;
  flex-flow: column;
  .title {
    height: 30px;
    line-height: 30px;
    padding: 0px 10px;
    color: #000;
    text-align: left;
    font-weight: bold;
  }
  .chart {
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px;
    box-sizing: border-box;
  }
}

.table-content {
  margin-top: 14px;
  height: 320px;

  overflow: auto;
}
.same-item {
  padding: 10px;
  padding-bottom: 0px;
}
.same-item:last-child {
  padding-bottom: 10px;
}
</style>
